/**
 * Canonical normalize-error lives in @korvo/core. This module was a byte-identical fork; collapsed to a
 * re-export 2026-06-13 (single source of truth; see docs/REFACTOR_ROADMAP.md Phase 0). All existing
 * `import { normalizeError, type NormalizedError } from '.../utils/normalize-error'` sites keep working.
 */
export { normalizeError, type NormalizedError } from '@korvo/core/lib/normalize-error';
